
  <select class="mdb-select md-form" searchable="Tìm..">
    <option value="" disabled selected>{{cbtitle}}</option>
    <option *ngFor="let pb of dsitem" value="pb.{{key}}"> {{pb.tenphong}}</option>
   
  </select>